import React from 'react';
import Container from '../../../containers/system/mailLogs/showMailLogsContainer';

export default function () {
  return (
    <Container />
  );
}
